import React, { Component, Fragment } from 'react';
import authService from '../api-authorization/AuthorizeService'
import { FormattedMessage } from 'react-intl';
import { Dialog, Transition } from '@headlessui/react';
import { Loading } from '../controls/Loading'
import Toast from '../controls/BaseToast'
import { CheckMessageId, LeftRightOption } from './../infrastructure/AppConstants';

export default class InfoIdDialog extends Component {
    constructor(props) {
        super(props);
        this.onClose = this.onClose.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleOnSubmit = this.handleOnSubmit.bind(this);
        this.state = { infoId: "", orderId: "", orderNum: "", InfoIdCheckError: "", orderNumCheckError: ""}
        this.onKeyUp = this.onKeyUp.bind(this);
        this.checkInfoId = this.checkInfoId.bind(this);
        this.checkOrderNum = this.checkOrderNum.bind(this);
    }

    componentDidMount() {
        this.props.onRef(this);
    }
    onChange(e) {
        const target = e.target;
        const value = target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }

    async onKeyUp(e) {
        e.preventDefault();
        if (e.keyCode == 13) {
            if (e.target.name == "orderNum" && this.state.orderNum.length > 0) {
                await this.checkOrderNum();
                if (!this.state.orderNumCheckError) {
                    this.infoIdInput.focus();
                }
            }
            else if (e.target.name == "infoId" && this.state.infoId.length > 0) {
                this.checkInfoId();
                if (!this.state.InfoIdCheckError && !this.state.orderNumCheckError) {
                    this.btnSubmit.focus();
                }
            }
        }
    }
    onClose() {
        this.setState({ infoId: "", orderId: "", orderNum: "", InfoIdCheckError: "", orderNumCheckError: "" });
        this.props.onClose();
    }

    checkInfoId() {
        const infoId = this.state.infoId.trim();
        if (!infoId.toLowerCase().startsWith("s") && !infoId.toLowerCase().startsWith("d")) {
            this.setState({
                InfoIdCheckError: CheckMessageId.InfoIdCheckError
            });
            return false;
        } else {
            this.setState({ InfoIdCheckError: "" });
            return true;
        }
    }

    async checkOrderNum() {
        let orderNum = this.state.orderNum.trim();
        if (!orderNum) {
            this.setState({ orderNumCheckError:"OrderNumRequired" });
            return false;
        }
        const token = await authService.getAccessToken();
        const response = await fetch('order/CheckOrderNum', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json', 'Authorization': `${token}` },
            body: JSON.stringify({
                'orderNum': orderNum
            })
        })
        if (response.status == 200) {
            let data = await response.json();
            if (data) {
                if (data.status != 0) {
                    this.setState({ orderNumCheckError: data.message });
                    return false;
                }
            }
            this.setState({ orderNumCheckError: "" });
            return true
        }
        return false;
    }
    async handleOnSubmit() {
        var ckResult = this.checkOrderNum();
        if (!ckResult) {
            return;
        }
        ckResult = await this.checkInfoId();
        if (!ckResult) {
            return;
        }
        const infoId = this.state.infoId.trim();
        const orderNum = this.state.orderNum.trim();
        this.loadingRef.showLoading();
        const token = await authService.getAccessToken();
        const response = await fetch('order/FinishOrder', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json', 'Authorization': `${token}` },
            body: JSON.stringify({
                'orderNum': orderNum,
                'infoId': infoId
            })
        })
        if (response.status == 200) {
            let data = await response.json();
            if (data) {
                if (data.status == 0) {
                    // this.props.callback && this.props.callback();
                }
                else {
                    Toast.error(data.message, 30000, "bottom-center");
                }
            }

        }
        else {
            console.error('response.status:' + response.status)
        }
        this.loadingRef.closeLoading();
        this.orderNumInput.focus();
        this.setState({ orderNum: "", infoId: "" });
    }
    render() {
        const open = this.props.open;
        return (
            <Transition.Root show={open} as={Fragment}>
                <Dialog
                    as="div"
                    static
                    className="fixed z-10 inset-0 overflow-y-auto"
                    open={open}
                    onClose={() => { }}
                >
                    <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                        </Transition.Child>

                        {/* This element is to trick the browser into centering the modal contents. */}
                        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                            &#8203;
                        </span>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                                <form className="bg-transparent">
                                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4  border-b border-gray-200">
                                        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                            <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900"><FormattedMessage id="FinishOrder" /></Dialog.Title>
                                        </div>
                                    </div>
                                    <div className="px-14 pt-6 pb-10 space-y-3">
                                        <div>
                                            <label><FormattedMessage id="OrderNum" /></label><br />
                                            <input ref={(ref) => { this.orderNumInput = ref }} className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" type="text" tabIndex="1" onKeyUp={this.onKeyUp} onBlur={this.checkOrderNum} name="orderNum" value={this.state.orderNum} onChange={this.onChange} />
                                        </div>
                                        <div className="text-red-400 -mt-1">{this.state.orderNumCheckError && <FormattedMessage id={this.state.orderNumCheckError} />}</div>
                                        <div className="mt-2">
                                            <label><FormattedMessage id="InfoId" /></label><br />
                                            <input ref={(ref) => { this.infoIdInput = ref }} className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" type="text" tabIndex="2" onKeyUp={this.onKeyUp} name="infoId" value={this.state.infoId} onChange={this.onChange} />
                                        </div>
                                        <div className="text-red-400 -mt-1">{this.state.InfoIdCheckError && <FormattedMessage id={this.state.InfoIdCheckError} />}</div>
                                    </div>
                                    <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                                        <button
                                            type="button"
                                            className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                                            onClick={this.onClose}><FormattedMessage id="Close" /></button>
                                        <button type="button" onClick={this.handleOnSubmit} name="btnSubmit" ref={(ref) => { this.btnSubmit = ref }}
                                            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm"><FormattedMessage id="Submit" /></button>

                                    </div>

                                </form>
                            </div>
                        </Transition.Child>
                    </div>
                    <Loading onRef={(ref) => { this.loadingRef = ref }} />
                </Dialog>

            </Transition.Root >
        )
    }
}